<div class="column-filter-container" (click)="$event.stopPropagation()">
  @if (requireChangesForApply && (hasFilterInput || hasActiveFilters || hasExternalChanges)) {
    <button class="mobile-filter-clear" type="button" (click)="clear()">
      {{ 'clear' | translate }}
    </button>
  }
  @if (sorting) {
    <div class="column-filter-header">
      @if (requireChangesForApply) {
        <div class="mobile-filter-section-title">{{ 'sort' | translate }}</div>
      }
      <button (click)="sortChange('asc')">
        @if (requireChangesForApply) {
          <mat-icon>
            {{
              sortDirection === 'asc' || sortDirection === 'Ascending'
                ? 'radio_button_checked'
                : 'radio_button_unchecked'
            }}
          </mat-icon>
        } @else if (ascIcons[columnType]) {
          <mat-icon>{{ ascIcons[columnType] }}</mat-icon>
        } @else {
          <mat-icon></mat-icon>
        }
        {{ ascSortLabel | translate }}
        @if (
          !requireChangesForApply && (sortDirection === 'asc' || sortDirection === 'Ascending')
        ) {
          <mat-icon class="check-icon">done</mat-icon>
        }
      </button>
      <button (click)="sortChange('desc')">
        @if (requireChangesForApply) {
          <mat-icon>
            {{
              sortDirection === 'desc' || sortDirection === 'Descending'
                ? 'radio_button_checked'
                : 'radio_button_unchecked'
            }}
          </mat-icon>
        } @else if (descIcons[columnType]) {
          <mat-icon>{{ descIcons[columnType] }}</mat-icon>
        } @else {
          <mat-icon></mat-icon>
        }
        {{ descSortLabel | translate }}
        @if (
          !requireChangesForApply && (sortDirection === 'desc' || sortDirection === 'Descending')
        ) {
          <mat-icon class="check-icon">done</mat-icon>
        }
      </button>
    </div>
  }
  <div class="column-filter-content">
    @if (requireChangesForApply && sorting) {
      <div class="mobile-filter-section-title">
        {{ mobileFilterSectionLabel | translate }}
      </div>
    }
    @if (showSearch && (isTextColumn || isSectionedList)) {
      <app-ui-input
        label="{{ 'search' | translate }}"
        [placeholder]="'pleaseStartTypingToFilter' | translate"
        [control]="searchControl"
        [showClearButton]="true"
      ></app-ui-input>
    }
    @if (columnData.enableOptionSearch && !isSectionedList) {
      <app-ui-input
        label="{{ 'search' | translate }}"
        [placeholder]="'pleaseStartTypingToFilter' | translate"
        [control]="optionSearchControl"
        [showClearButton]="true"
      ></app-ui-input>
    }
    @if (isDateColumn) {
      <div class="date-range">
        <app-shared-ui-datepicker
          [required]="false"
          [control]="dateFromControl"
          label="{{ 'from' | translate | titlecase }}"
        ></app-shared-ui-datepicker>
        <app-shared-ui-datepicker
          [required]="false"
          [control]="dateToControl"
          label="{{ 'to' | translate | titlecase }}"
        ></app-shared-ui-datepicker>
      </div>
    }

    @if (isNumberColumn) {
      <div class="numeric-range">
        <app-ui-input
          label="{{ 'from' | translate | titlecase }}"
          [control]="fromControl"
          type="number"
        ></app-ui-input>
        <app-ui-input
          label="{{ 'to' | translate | titlecase }}"
          [control]="toControl"
          type="number"
        ></app-ui-input>
      </div>
    }
    @if (isBooleanColumn) {
      <app-shared-ui-radio
        [control]="booleanControl"
        [options]="booleanControlOptions"
      ></app-shared-ui-radio>
    }
    @if (isSectionedList) {
      <div class="sectioned-option-list">
        @for (section of optionSections; track section.property) {
          <div class="option-section">
            <div class="option-section-title">{{ section.labelKey | translate }}</div>
            @for (control of section.optionControls; track control.id) {
              <app-shared-ui-checkbox
                label="{{ control.label | translate }}"
                [control]="control.control"
              ></app-shared-ui-checkbox>
            }
          </div>
        }
      </div>
    } @else {
      <div class="option-list">
        @for (control of optionControlMap; track control.id) {
          <app-shared-ui-checkbox
            label="{{ control.label | translate }}"
            [control]="control.control"
          ></app-shared-ui-checkbox>
        }
      </div>
    }
  </div>
  @if (columnData.allowNullFilter) {
    <div class="column-filter-checkboxes">
      <app-shared-ui-checkbox
        label="{{ 'noDate' | translate | titlecase }}"
        [control]="onlyNullControl"
      ></app-shared-ui-checkbox>
    </div>
  }
  <div class="column-filter-footer">
    @if (!requireChangesForApply) {
      <app-ui-button
        buttonType="secondary"
        [text]="'cancel' | translate"
        (click)="cancel()"
      ></app-ui-button>
      <app-ui-button
        buttonType="secondary"
        [text]="'clear' | translate"
        (click)="clear()"
      ></app-ui-button>
    }
    <app-ui-button
      color="primary"
      [text]="'apply' | translate"
      [disabled]="!canApply"
      (click)="apply()"
    ></app-ui-button>
  </div>
</div>
